<template>
  <div class="ai-intelligent-vehicle-management">
    <top-nav :banner="data.banner" color="#333333" isParent></top-nav>
    <tech-empowerment></tech-empowerment>
    <product-list></product-list>
    <customer-wall></customer-wall>
    <footer-resolution></footer-resolution>
    <my-footer></my-footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TechEmpowerment from './components/tech-empowerment.vue';
import SelfDevelopedProducts from './components/self-developed-products.vue';
import CustomerWall from '@/views/index-view/customer-wall.vue';

export default {
  components: {
    TechEmpowerment,
    SelfDevelopedProducts,
    CustomerWall
  },
  computed: {
    ...mapGetters(['globalData']),
    data() {
      return this.globalData['ai-intelligent-vehicle-management'];
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-intelligent-vehicle-management {
  background: #ffffff;

  ::v-deep .banner-item-brief {
    width: 42%;
    font-size: 24px;
    line-height: 1.5;
    color: white!important;
    text-shadow: 1px 1px 2px #000;
  }

  ::v-deep .banner-item-title {
    color: white!important;
    text-shadow: 1px 1px 2px #000;
  }

  ::v-deep .banner-list .banner-item .banner-buttons {
    bottom: 18%;
  }
}
</style>
